import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import SignUpFormStep1 from '../SignUpFormStep1';
import SignUpFormStep2 from '../SignUpFormStep2';
import SignUpFormStep3 from '../SignUpFormStep3';

const SignUpForm = ({
  fields,
  activeStep
}) => (
  <Fragment>
    {activeStep === 0 && (
      <SignUpFormStep1
        fields={fields}
      />
    )}
    {activeStep === 1 && (
      <SignUpFormStep2
        fields={fields}
      />
    )}
    {activeStep === 2 && (
      <SignUpFormStep3
        fields={fields}
      />
    )}
  </Fragment>
);

SignUpForm.propTypes = {
  fields: PropTypes.instanceOf(Object).isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default SignUpForm;
